import { useQuery } from "react-query";
import { useApiError } from "src/hooks/useApiError";
import { USE_MOCK_DATA } from "src/config/config";
import { mockCreatedServiceList } from "src/mocks/createdServiceListMock";
import { getCreatedServiceList } from "src/service/cloud";

interface IUseCreatedServiceListProps {
  enabled?: boolean;
}

// 로그인 한 사용자 기준 서비스 목록 조회
export function useCreatedServiceList({
  enabled = true,
}: IUseCreatedServiceListProps = {}) {
  const { handleError } = useApiError();

  const { isLoading: isLoadingCreatedServiceList, data: createdServiceList } =
    useQuery(
      ["getCreatedServiceList"],
      async () =>
        USE_MOCK_DATA ? mockCreatedServiceList : await getCreatedServiceList(),
      {
        enabled,
        onError: handleError,
      },
    );

  return { isLoadingCreatedServiceList, createdServiceList };
}
